import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { DfDomModule } from '@df/dom/df-dom.module';
import { ToggleClassDirective } from '@df/ui/toggle/toggle-class.directive';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { OverlayComponent } from 'projects/app-default/src/app/common/overlay/overlay.component';
import { PageSearchOutletComponent } from '../../../search/outlet/page-search-outlet.component';
import { NPageSearch } from '../../../search/page-search.interfaces';
import { NPageHeader } from '../../page-header.component';
import { PageHeaderMaganavContentAreaDirective } from './area/page-header-meganav-content-area.directive';

@Component({
    imports: [
        OverlayComponent,
        ToggleClassDirective,
        ICmsClientModule,
        DfDomModule,
        PageSearchOutletComponent,
        PageHeaderMaganavContentAreaDirective
    ],
    selector: 'page-header-meganav-content',
    templateUrl: 'page-header-meganav-content.html',
    styleUrls: ['page-header-meganav-content.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderMeganavContentComponent extends UiComponent implements OnInit {
    /**
     * Meganav items
     */
    @Input()
    items?: NPageHeader.IMeganavItem[];

    readonly toggleService = inject(ToggleService);

    /**
     * Group id for toggle service
     */
    readonly toggleGroupId = NPageHeader.MEGANAV_GROUP_ID;

    /**
     * Group id for toggle service
     */
    readonly searchMeganavKey = NPageSearch.SEARCH_MEGANAV_KEY;

    onMouseIn(index: number): void {
        if (!this.client.isCms) {
            this.toggleService.open([this.toggleGroupId, index]);
        }
    }

    onMouseOut(index: number): void {
        if (!this.client.isCms) {
            this.toggleService.close([this.toggleGroupId, index], { delay: 300 });
        }
    }

    protected getItemWithId(item: NPageHeader.IMeganavItem): NPageHeader.IMeganavItem {
        item.id = 'meganav-content-item';
        return item;
    }
}
